import * as react_components from "../reactcomponent.js"
import * as translations_editor from "./translations_editor.js"
import { getGlobalSettings } from "../settings.js"
import { Innosoft_InnoBI_Controllers_StatisticUiController as StatisticUiController, Innosoft_InnoBI_Controllers_StatisticUi as StatisticUi } from "../generated_api/generated_api.js"
import { DropDownList } from "../components/drop_down_list.js"
import { DialogHelper } from "../../core/util/dialogHelper.js";
import { Menu } from "../../core/components/menu.js"
import { CategoryEditor } from "./category_editor.js"
import { General } from "../../../siteManagement/general.js"
import { Grid } from "../../core/components/grid.js"
import { Helper } from "../../core/util/helper.js"
import React from "react";


export class StatisticUiList extends React.Component<any, any>{
    private gridOptions;

    constructor(props) {
        super(props);
        let globalSettings = getGlobalSettings();
        this.state = { statistics: [], statistics_all: [], basePath: globalSettings.GetSettings().INNO_BASE_PATH, isInternalUser: globalSettings.GetSettings().INNO_IS_INTERNAL_USER };
        this.gridOptions = this.createGridOptions();
        General.Sheet.Manager.getTopMostSheet().setTitle(Helper.getTranslation("Statistik.Statistiken"));
    }

    sanitizeStatistictsOverrides(statarr: StatisticUi[]): StatisticUi[] {
        let tmp: StatisticUi[] = [];

        if (statarr) {
            statarr.forEach((val) => {
                let doAdd = true;

                if (val.Overrides != "") {

                    statarr.forEach((oval) => {
                        if (oval.Overrides == val.Id) {
                            if (doAdd)
                                doAdd = false;
                        }
                    }
                    );
                }

                if (doAdd)
                    tmp.push(val);
            });
        }

        return tmp;
    }

    componentDidMount() {
        new StatisticUiController().GetAllStatisticsUngrouped((result) => {
            this.setState({ statistics_all: result, statistics: this.sanitizeStatistictsOverrides(result) });
        });
    }


    handleAddNewOrEdit = (statisticId, statisticName, categoryId) => {
        this.setState({ statisticIdValue: statisticId, nameValue: statisticName, categoryValue: categoryId, formState: "createNewOrEdit" });
    }

    handleDelete = async () => {
        const shouldDelete = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"))
        if (!shouldDelete) {
            return;
        }
        var selectedItem = this.state.selectedItem[0];
        if (selectedItem) {
            this.setState({ formState: "default" });
            var that = this;
            new StatisticUiController().DeleteStatistic(selectedItem.Id, (result) => {
                new StatisticUiController().GetAllStatisticsUngrouped((result) => {
                    this.setState({ statistics: result });
                });
            });
        }
    }

    handleClose = () => {
        this.setState({ formState: "default" });
    }

    handleSave = () => {
        this.setState({ formState: "default" });
        var that = this;
        new StatisticUiController().CreateNewOrEditStatistic({ Id: this.state.statisticIdValue, Name: this.state.nameValue, CategoryId: this.state.categoryValue }, (result) => {
            var statistics = that.state.statistics.slice();
            if (that.state.statisticIdValue == 0) {
                statistics.push(result);
            } else {
                for (var i = 0; i < statistics.length; i++) {
                    if (statistics[i].Id == result.Id) {
                        statistics[i] = result;
                        break;
                    }
                }
            }
            that.setState({ statistics: statistics });
        });
    }

    handleCategoryChange = (category) => {
        this.setState({ categoryValue: category });
    }

    handleNameChange = (name) => {
        this.setState({ nameValue: name });
    }

    handleExportSelected = () => {
        const Ids = $.map(this.state.selectedItem, (item) => item.Id);
        const url = "api/StatisticUi/UiService/ExportStatistic?" + $.param({ Ids: Ids });
        this.openInNewBrowserTab(url);
    }

    public openInNewBrowserTab = (url: string) => {
        const dummyLink = $("<a>").text("click me!").attr({ href: url, target: "_blank" });
        $("body").append(dummyLink);
        dummyLink[0].click();
        dummyLink.remove();
    }

    editRow = () => {
        var dataItem = this.state.selectedItem[0];

        if (dataItem) {
            this.handleAddNewOrEdit(dataItem.Id, dataItem.UntranslatedName, dataItem.CategoryId);
        }
    }

    handleSelectedItemChanged = (items) => {

        if (Array.isArray(items)) {
            this.setState({ selectedItem: items });
        }
        else if (items == null) {
            this.setState({ selectedItem: null });
        }
        else {
            this.setState({ selectedItem: [items] });
        }

    }

    editCategories = () => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.mountContent(CategoryEditor, {});
        });
    }

    handleImport = () => {
        this.setState({ formState: "import" });
    }

    handleImportFinished = () => {
        location.reload();
    }

    copy = () => {
        let that = this;

        new StatisticUiController().CopyStatistic({ id: this.state.selectedItem[0].Id }, (result) => {
            var statistics = that.state.statistics.slice();
            statistics.push(result);
            that.setState({ statistics: statistics });
        });
    }

    override = () => {
        let that = this;

        const selectedStatistic = this.state.selectedItem[0];
        new StatisticUiController().OverrideInternalStatistic({ id: selectedStatistic.Id }, (newStatistic) => {
            var statistics: StatisticUi[] = that.state.statistics.slice();

            for (var i = 0; i < statistics.length; i++) {
                if (statistics[i].Id == selectedStatistic.Id) {
                    statistics.splice(i, 1);
                    break;
                }
            }


            statistics.push(newStatistic);

            that.setState({ statistics: statistics });
        });
    }

    canOverride = (selectedItem: StatisticUi[]) => {
        let res = selectedItem && selectedItem.length == 1 && (selectedItem[0].IsInternal === 1);

        if (res === true) {
            let that = this;
            let statistics = that.state.statistics_all;
            for (var i = 0; i < statistics.length; i++) {
                if (statistics[i].Overrides == selectedItem[0].Id) {
                    res = false;
                    break;
                }
            }
        }

        return !res;
    }
    openNewStatisticSheet = (params, e) => {
        e.preventDefault();
        const sheet = General.Sheet.Manager.createSheetWithUrl(`Statistic/uiBuilderDetail?id=${params.Id}`);
    }

    createLink = (params) => {
        return <a href={`uiBuilderDetail?id=${params.Id}`} onClick={this.openNewStatisticSheet.bind(this, params)}>{params.Name}</a >;
    }

    createGridOptions = (): kendo.ui.GridOptions => {
        const gridOptions: any = {
            filterable: true,
            selectable: "multiple",
            columns: [
                { field: "Name", title: "Name", reactTemplate: this.createLink },
                { field: "CategoryName", title: "Category" },
                { field: "IsInternal", width: "150px", title: "Is internal", template: '#if(Overrides){#<h4 style="text-align: center; color: transparent; text-shadow: 0 0 0 red">&\\#9941;<\h4>#} else if(IsInternal){#<h4 style="text-align: center; color: transparent; text-shadow: 0 0 0 red">&\\#10071;<\h4>#}#' }
            ]
        };
        return gridOptions;
    }

    render() {
        let dialog;
        if (this.state.formState == "createNewOrEdit") {
            dialog = <NewOrEditStatisticDialog basePath={this.state.basePath} onClose={this.handleClose} onSave={this.handleSave} onCategoryChange={this.handleCategoryChange} onNameChange={this.handleNameChange} statisticIdValue={this.state.statisticIdValue} nameValue={this.state.nameValue} categoryValue={this.state.categoryValue} />
        } else if (this.state.formState == "import") {
            dialog = <ImportDialog onClose={this.handleClose} onSave={this.handleImportFinished} />
        }
        else if (this.state.formState == "editCategories") {
            dialog = <EditCategoriesDialog onClose={this.handleClose} />
        }
        const overrideButton = this.state.isInternalUser === 1 ? null : <react_components.InnoButtonCustom label="Override" onClick={this.override} disabled={this.canOverride(this.state.selectedItem)} />;
        return (
            <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                {dialog}

                <Menu entries={[
                    { text: "New", onClick: this.handleAddNewOrEdit.bind(this, 0, "", "") },
                    { text: "Delete", onClick: this.handleDelete, show: !!this.state.selectedItem && this.state.selectedItem.length == 1 },
                    { text: "Edit categories", onClick: this.editCategories },
                    { text: "Edit head data", onClick: this.editRow, show: !!this.state.selectedItem && this.state.selectedItem.length == 1 },
                    { text: "Export", onClick: this.handleExportSelected, show: !!this.state.selectedItem },
                    { text: "Import", onClick: this.handleImport },
                    { text: "Copy", onClick: this.copy, show: !!this.state.selectedItem && this.state.selectedItem.length == 1 },
                    { text: "Override", onClick: this.override, show: this.state.isInternalUser !== 1 && !this.canOverride(this.state.selectedItem) }
                ]} onSelect={() => { }} enableMenuItem={() => true} handleEval={() => { }} />

                {this.state.statistics ? <Grid id="STATISTIC_UI_LIST" data={this.state.statistics} options={this.gridOptions} onSelectionChanged={this.handleSelectedItemChanged} /> : null}

            </div>);
    }
};

class NewOrEditStatisticDialog extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = { categories: [] };
    }

    componentDidMount() {
        new StatisticUiController().GetAllStatisticCategories((result) => {
            if (!Array.isArray(result)) {
                result = new Array();
            }
            result.unshift({ Id: "", Name: "" });

            this.setState({ categories: result });
        })
    }

    handleClose = () => {
        this.props.onClose();
    }

    handleSave = () => {
        this.props.onSave();
    }

    handleCategoryChange = (categoryValue) => {
        this.props.onCategoryChange(categoryValue);
    }

    handleNameChange = (nameValue) => {
        this.props.onNameChange(nameValue);
    }

    handleShowTranslationPicker = () => {
        this.setState({ showTranslationsPicker: true });
    }

    handleCloseTranslationsDialog = () => {
        this.setState({ showTranslationsPicker: false });
    }

    handleSelectTranslation = (key) => {
        this.handleNameChange('{{{' + key + '}}}');
        this.setState({ showTranslationsPicker: false });
    }

    render() {
        let title = (this.props.statisticIdValue > 0) ? "Edit statistic" : "Add new statistic";
        let translationsEditor = this.state.showTranslationsPicker ? <translations_editor.TranslationsEditor onSave={this.handleSelectTranslation} onClose={this.handleCloseTranslationsDialog} contextVariables={{ INNO_BASE_PATH: this.props.basePath }} /> : null;
        return (
            <react_components.BasicDialog title={title} onClose={this.handleClose} onSave={this.handleSave}>
                <react_components.KendoMaskedTextBox label="Name" name="name" value={this.props.nameValue} onTextChange={this.handleNameChange} />
                <DropDownList label="Category" value={this.props.categoryValue} data={this.state.categories} valueField="Name" keyField="Id" onChange={this.handleCategoryChange} />
                {translationsEditor}
            </react_components.BasicDialog>);
    }
};

class EditCategoriesDialog extends React.Component<{ onClose: () => void }, any>{

    render() {
        return <react_components.BasicDialog
            title="Edit categories"
            onClose={this.props.onClose}
            okayLabel="Import">
            <CategoryEditor />
        </react_components.BasicDialog>
    }
}

class ImportDialog extends React.Component<any, any>{
    private fileInput;
    constructor(props: any, context: any) {
        super(props, context);
        this.state = { categories: [] };
    }
    //componentWillMount() {

    //}

    handleClose = () => {
        this.props.onClose();
    }


    handleSave = async () => {
        if (this.state.exportedData) {
            if (this.hasImportedStatisticsOrDataSources()) {
                const result = await DialogHelper.confirm("Statistics or datasources with the same id will be overwritten!");

                if (!result) {
                    return;
                }
            }
            new StatisticUiController().ImportStatistics(this.state.exportedData, (response) => {
                this.setState({ statisticExport: this.state.exportedData });
                this.props.onSave();
            }, () => {
                DialogHelper.alert("Could not import data");
            });
        } else {
            DialogHelper.alert("No data selected");
        }

    }

    handleCategoryChange = (categoryValue) => {
        this.props.onCategoryChange(categoryValue);
    }

    handleNameChange = (nameValue) => {
        this.props.onNameChange(nameValue);
    }

    handleShowTranslationPicker = () => {
        this.setState({ showTranslationsPicker: true });
    }

    handleCloseTranslationsDialog = () => {
        this.setState({ showTranslationsPicker: false });
    }

    handleSelectTranslation = (key) => {
        this.handleNameChange('{{{' + key + '}}}');
        this.setState({ showTranslationsPicker: false });
    }

    handleFileChange = (e) => {
        const file = this.fileInput.files[0];

        var reader = new FileReader();

        reader.onload = (e) => {
            try {
                const exportedData = JSON.parse(reader.result as string);
                new StatisticUiController().CheckStatistics(exportedData, (result) => {
                    this.setState({ exportedData: exportedData, validationResult: result });
                });

            } catch (ex) {
                DialogHelper.alert("Could not parse selected file");
            }
        }
        reader.readAsText(file);
    }

    hasImportedStatisticsOrDataSources = () => {
        return this.state.validationResult && (this.state.validationResult.AvailableStatistics && Object.keys(this.state.validationResult.AvailableStatistics).length > 0)
            || (this.state.validationResult.AvailableDatasources && Object.keys(this.state.validationResult.AvailableDatasources).length > 0)
    }

    renderStatisticAvailableIndicator = (id: string) => {
        if (this.state.validationResult && this.state.validationResult.AvailableStatistics && this.state.validationResult.AvailableStatistics[id]) {
            return <div title="Statistic with the same id is already available" style={{ display: "inline", color: "red" }}>*</div>;
        }
        return null
    }

    renderDataSourceAvailableIndicator = (id: string) => {
        if (this.state.validationResult && this.state.validationResult.AvailableDatasources && this.state.validationResult.AvailableDatasources[id]) {
            return <div title="Datasource with the same id is already available" style={{ display: "inline", color: "red" }}>*</div>;
        }
        return null
    }

    renderStatistics = (data) => {
        if (!data || !data.Statistics || data && data.Statistics.length == 0) {
            return <div style={{ height:"400px" }}>No data to import selected</div>
        }

        return (
            <div style={{ height: "400px" }}>
                <h3>Statistics</h3>
                <ul>
                    {data.Statistics.map((s => <li>{s.NAME} {this.renderStatisticAvailableIndicator(s.ID)}</li>))}
                </ul>
                <h3>Datasources</h3>
                <ul>
                    {data.DataSources ? data.DataSources.map((s => <li>{s.SERVICE_NAME}{this.renderDataSourceAvailableIndicator(s.ID)}</li>)) : null}
                </ul>
            </div>);
    }

    render() {
        const title = "Import statistic";
        const data = this.state.exportedData;

        return (
            <react_components.BasicDialog
                width="500px"
                title={title}
                onClose={this.handleClose}
                onSave={this.handleSave}
                okayLabel={"Import"}>
                <div>
                    <label>
                        Select file:
                        <input ref={(element) => this.fileInput = element} type="file" onChange={this.handleFileChange} />
                    </label>
                </div>
                {this.renderStatistics(data)}
            </react_components.BasicDialog>);
    }
};

